import { render, staticRenderFns } from "./partner-income.vue?vue&type=template&id=544ce65d&scoped=true&"
import script from "./partner-income.vue?vue&type=script&lang=js&"
export * from "./partner-income.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544ce65d",
  null
  
)

export default component.exports